<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount,toRefs,watch } from 'vue'
import CustomList from "../../../../compositions/CustomList.vue";
import ModalDialog from "../../../../compositions/ModalDialog.vue";
import SearchBox from "../../../../compositions/SearchBox.vue";
import SelectBox from "../../../../compositions/SelectBox.vue";
import Chart from "../../../../compositions/Chart.vue";
import SummaryMedicineComponent from '../../../Common/SummaryMedicineComponent.vue';
import config from "../../../../config.js";
import { errorAlert } from "../../../../plugins/alert";
import { getFieldValue } from "../../../../plugins/utility";
import qs from 'qs';
import axios from '../../../../plugins/axios.ts';
import { deepCopy } from "../../../../plugins/utility";
import HelpAction from '../../../../compositions/HelpAction.vue';

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    identityId: {
      typ:Number,
      default:() => {
        return 0;
      }
    },
    searchParams: {
      typ:Object,
      default:() => {
        return {};
      }
    },
    isVisible:{
        type:Boolean,
        default: () => {
            return false;
        }
    }
})

const { isVisible,identityId,searchParams } = toRefs(props);
const listRef = ref();
const searchParamsData = reactive(props.searchParams);
const medicineSummaryFields = reactive([
  {field_name: '薬局名', field_key: 'pharmacy_name', width: '30%', align: 'text-left',sorted:true},
  {field_name: '採用品', field_key: 'product_detail_name', width: '20%', align: 'text-left',sorted:true},
  {field_name: '廃棄理由', field_key: 'stock_reason', width: '5%', align: 'text-center',sorted:true},
  //{field_name: '最新<br>薬価', field_key: 'medicine_unit_price', width: '5%', align: 'text-center',sorted:true},
  //{field_name: '最新<br>購入額', field_key: 'current_unit_price', width: '5%', align: 'text-center',sorted:true},
  {field_name: '廃棄数', field_key: 'stock_number', width: '5%', align: 'text-center',sorted:true},
  {field_name: '薬価在庫金額', field_key: 'stock_price_org', width: '5%', align: 'text-center',sorted:true},
  {field_name: '在庫金額(税込)', field_key: 'stock_price', width: '5%', align: 'text-center',sorted:true},
]);
const summaryData = reactive([]);
const summaryChartData = reactive([]);
const summaryChartHistoryData = reactive([]);
const summaryHistoryType = ref(0);
const summaryHistoryOptions = reactive([
  {id:0,name:'年単位'},
  {id:1,name:'月単位'},
]);
const onSummaryHistoryTypeChange = (value,label) => {
  summaryHistoryType.value = value;
  getSummaryHistory();
}
const getSummary = async () => {
  let params = deepCopy(searchParamsData);
  const paramsSerializer = (params) => qs.stringify(params,{ arrayFormat: 'repeat'});
  let response = await axios.get(props.apis.summary_stock_waste_summary,{params:params,paramsSerializer});
  summaryData.splice(0);
  summaryData.push(response.data.summary);
  let chartPieRecord = {};
  chartPieRecord.labels = ['紛失','破損','有効期限切れ','返品','零売','その他'];
  chartPieRecord.datasets = [
    {
      type:'pie',
      label:'廃棄理由割合',
      backgroundColor:['#00fd02','#FF6384','#36A2EB','#EB3645','#EE8A19','#A5A4A4'],
      data:[response.data.summary.lost_price,response.data.summary.damage_price,response.data.summary.expired_price,response.data.summary.return_price,response.data.summary.zero_sell_price,response.data.summary.other_price],
    }
  ];
  summaryChartData.splice(0);
  summaryChartData.push(chartPieRecord);
}
const getSummaryHistory = async () => {
  let params = deepCopy(searchParamsData);
  params['history_type'] = summaryHistoryType.value;
  const paramsSerializer = (params) => qs.stringify(params,{ arrayFormat: 'repeat'});
  let response = await axios.get(props.apis.summary_stock_waste_summary_list,{params:params,paramsSerializer});
  let chartRecord = {};
  chartRecord.labels = [];
  for (let i=0;i<response.data.list.length;i++) {
    chartRecord.labels.push(response.data.list[i].summary_key);
  }
  chartRecord.datasets = [];
  let lost_price = [];
  let damage_price = [];
  let expired_price = [];
  let return_price = [];
  let zero_sell_price = [];
  let other_price = [];
  for (let i=0;i<response.data.list.length;i++) {
    lost_price.push(response.data.list[i].lost_price);
    damage_price.push(response.data.list[i].damage_price);
    expired_price.push(response.data.list[i].expired_price);
    return_price.push(response.data.list[i].return_price);
    zero_sell_price.push(response.data.list[i].zero_sell_price);
    other_price.push(response.data.list[i].other_price);
  }
  chartRecord.datasets.push({
      type:'bar',
      label:'紛失',
      backgroundColor:'#2dc181',
      data:lost_price,
  });
  chartRecord.datasets.push({
      type:'bar',
      label:'破損',
      backgroundColor:'#FF6384',
      data:damage_price,
  });
  chartRecord.datasets.push({
      type:'bar',
      label:'有効期限切れ',
      backgroundColor:'#36A2EB',
      data:expired_price,
  });
  chartRecord.datasets.push({
      type:'bar',
      label:'返品',
      backgroundColor:'#EB3645',
      data:return_price,
  });
  chartRecord.datasets.push({
      type:'bar',
      label:'零売',
      backgroundColor:'#EE8A19',
      data:zero_sell_price,
  });
  chartRecord.datasets.push({
      type:'bar',
      label:'その他',
      backgroundColor:'#A5A4A4',
      data:other_price,
  });

  summaryChartHistoryData.splice(0);
  summaryChartHistoryData.push(chartRecord);
}

const refreshView = (force=false) => {
  if (isVisible.value == false) {
    return;
  }
  if (typeof listRef.value !== 'undefined') {
    listRef.value.resetItem();
    getSummary();
    getSummaryHistory();
  }
}
watch(isVisible,(newValue, oldValue) => {
  if (newValue) {
    refreshView();
  }
})
watch(identityId,(newValue, oldValue) => {
  refreshView();
})
watch(searchParams,(newValue, oldValue) => {
  refreshView();
},{deep:true})
onMounted(() => {
  refreshView();
});
</script>

<style scoped>
.summary-header {
  min-height:54px;
}
.summary-chart {
  min-height:342px;
}
</style>
<template>
<div v-show="isVisible" class="relative">
  <div class="absolute top-2 left-2" style="z-index:39;">
    <help-action
      help-key="dashboard_waste_help"
    ></help-action>
  </div>
  <div class="pl-8 w-full border flex items-center justify-between px-4 summary-header" v-for="(summaryRecord,index) in summaryData" :key="index">
    <div class="text-center">
      <div><span class="border-b text-sm">紛失金額(税込み)</span></div>
      <div class="text-bold text-lg">\{{ summaryRecord.lost_price.toLocaleString() }}</div>
    </div>
    <div class="text-center">
      <div><span class="border-b text-sm">紛失品数</span></div>
      <div class="text-bold text-lg">{{ summaryRecord.lost_count.toLocaleString() }}</div>
    </div>
    <div class="text-center">
      <div><span class="border-b text-sm">破損金額(税込み)</span></div>
      <div class="text-bold text-lg">\{{ summaryRecord.damage_price.toLocaleString() }}</div>
    </div>
    <div class="text-center">
      <div><span class="border-b text-sm">破損品数</span></div>
      <div class="text-bold text-lg">{{ summaryRecord.damage_count.toLocaleString() }}</div>
    </div>
    <div class="text-center">
      <div><span class="border-b text-sm">有効期限切れ金額(税込み)</span></div>
      <div class="text-bold text-lg">\{{ summaryRecord.expired_price.toLocaleString() }}</div>
    </div>
    <div class="text-center">
      <div><span class="border-b text-sm">有効期限切れ品数</span></div>
      <div class="text-bold text-lg">{{ summaryRecord.expired_count.toLocaleString() }}</div>
    </div>
    <div class="text-center">
      <div><span class="border-b text-sm">返品金額(税込み)</span></div>
      <div class="text-bold text-lg">\{{ summaryRecord.return_price.toLocaleString() }}</div>
    </div>
    <div class="text-center">
      <div><span class="border-b text-sm">返品品数</span></div>
      <div class="text-bold text-lg">{{ summaryRecord.return_count.toLocaleString() }}</div>
    </div>
    <div class="text-center">
      <div><span class="border-b text-sm">零売金額(税込み)</span></div>
      <div class="text-bold text-lg">\{{ summaryRecord.zero_sell_price.toLocaleString() }}</div>
    </div>
    <div class="text-center">
      <div><span class="border-b text-sm">零売品数</span></div>
      <div class="text-bold text-lg">{{ summaryRecord.zero_sell_count.toLocaleString() }}</div>
    </div>
    <div class="text-center">
      <div><span class="border-b text-sm">その他金額(税込み)</span></div>
      <div class="text-bold text-lg">\{{ summaryRecord.other_price.toLocaleString() }}</div>
    </div>
    <div class="text-center">
      <div><span class="border-b text-sm">その他品数</span></div>
      <div class="text-bold text-lg">{{ summaryRecord.other_count.toLocaleString() }}</div>
    </div>
  </div>
  <div class="w-full mt-1 flex flex-row summary-chart">
    <div class="w-1/5" v-for="(summaryChartRecord,index) in summaryChartData" :key="index">
      <div class="font-bold">【廃棄理由割合】</div>
      <div>
        <chart
          chart-type="pie"
          height="280px"
          :chart-data="summaryChartRecord"
        ></chart>
      </div>
    </div>
    <div class="w-4/5 pl-4" v-for="(summaryChartHistoryRecord,index) in summaryChartHistoryData" :key="index">
      <div class="font-bold">【時系列(廃棄理由)】</div>
      <div class="w-1/5">
        <select-box
          :value="summaryHistoryType"
          :options="summaryHistoryOptions"
          :on-change="onSummaryHistoryTypeChange"
        ></select-box>
      </div>
      <div>
        <chart
          chart-type="bar"
          height="280px"
          :chart-data="summaryChartHistoryRecord"
        ></chart>
      </div>
    </div>
  </div>
  <div class="w-full mt-1">
    <div class="font-bold">【廃棄一覧】</div>
    <custom-list
      ref="listRef"
      :api-url="apis.summary_stock_waste_list"
      :table-fields="medicineSummaryFields"
      :option-fields="searchParamsData"
      :is-downloadable="true"
      font-size="0.8em"
      height="40vh"
    >
    <template v-slot:item="slotProps">
      <summary-medicine-component
        :apis="apis"
        :item="slotProps.item"
        :fields="medicineSummaryFields"
      ></summary-medicine-component>
    </template>
    </custom-list>
  </div>
</div>
</template>
